<template>
    <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading"
      >Loading ...
    </a-card>
    <a-form :form="form" ref="forms" v-else>
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
          <a-form-item label="Report Date">
            <a-date-picker
              placeholder="Select Date"
              :disabled="true"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tanggal_pelaporan',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.tanggal_pelaporan,
                },
              ]"
            />
          </a-form-item>
  
          <a-form-item label="End User CC">
            <a-select
              showSearch
              allowClear
              :filter-option="filterOptionTlc"
              option-filter-prop="children"
              v-decorator="['end_user', { rules: [{ required: true }],initialValue: initialData.id_user_cc, }]"
              :disabled="dataList.length>0"
            >
              <a-select-option v-for="user in getEndUserCCFiltered" :key="user.id_user_cc"
                >{{ user.tlc_user }} ({{user.type_cc}} / {{ formatRupiah(user.limit_kredit) }})</a-select-option
              >
            </a-select>
          </a-form-item>
  
          <a-row :gutter="24">
            <a-col span="0" style="display:none">
              <a-form-item label="Activity Type" v-if="1==0 && (($refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV')) || (initialData.cost_center && initialData.cost_center.includes('MARDEV')))">
                <a-select placeholder="Please Select" 
                ref="refactivity_type"
                v-decorator="[
                  'type_activity',
                  { rules: [{ required: true }], initialValue: initialData.type_activity },
                ]"
                :disabled="(dataList && dataList.length>0) || 1==1"
                @change="changeActivity_type" class="width-full">
                  <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="24">
              <a-form-item label="Activity" v-if="1==0 && (($refs.refactivity_type && $refs.refactivity_type.value=='Non Project') || 'Non Project'==initialData.type_activity)">
                <a-select placeholder="Please Select" 
                v-decorator="[
                  'activity',
                  { rules: [{ required: true }], initialValue: initialData.activity },
                ]" 
                :disabled="dataList && dataList.length>0"
                class="width-full">
                  <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Pipeline" v-if="1==0 && (($refs.refactivity_type && $refs.refactivity_type.value=='Project Penetration') || 'Project Penetration'==initialData.type_activity)">
                <a-select
                  :disabled="dataList && dataList.length>0"
                  showSearch
                  :loading="load.pipeline"
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="[
                    'pipeline_id',
                    {
                      rules: [{ required: true }],
                      initialValue: initialData.pipeline_id,
                    },
                  ]"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                    [{{ item.pipeline_no}}] {{ item.definitions }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
  
          <a-form-item label="Approval" style="display:none">
            <a-select
              placeholder="Please select Executive"
              v-decorator="[
                'bod',
                { rules: [{ required: true }], initialValue: initialData.bod },
              ]"
              disabled
            >
              <a-select-option v-for="data in wo_bod" :key="data.value"
                >{{ data.value }} - {{ data.text }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import moment from "moment";
  import _ from "lodash";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  
  export default {
    name: "Informasi",
    props: {
      data: {},
      others: {},
      dataList: {},
      mode: String,
      type: String,
      // eslint-disable-next-line vue/require-prop-type-constructor
      active: false,
    },
    mixins:[CurrencyFormat],
    data() {
      return {
        listNoSPPD: [],
        pageLoading: true,
        pic: "",
        pic_name: "",
        bod: "",
        wo_bod: [],
        costCenter: [],
        peruntukan: [],
        pipelineList: [],
        load:{
          pipeline: false
        }
      };
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },
    created() {
      this.$store.dispatch("FETCH_ENDUSER_CC");
      this.$store.dispatch("FETCH_ENDUSER_CC_TICKET");
      if (this.mode === "Create" && !this.active) {
        // this.listNoSPPD = [];
        this.bod = "ADI";
        this.fetchBodPic();
      } else {
        this.pageLoading = false;
        this.bod = "ADI";
        this.fetchBodPic();
      }
    },

    watch: {
    },

    async mounted(){
      if(this.data){

      }
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getDefaultDateFormat",
        "getStandartFormatDate",
        "getAnggaran",
        "getMARDEVActivity",
        "getEndUserCC",
        "getEndUserCCTicket",
      ]),
      initialData() {
        if (this.data === undefined || this.data.length <= 0) {
          return {
            tanggal_pelaporan: moment(),
            pic: this.pic,
            bod: this.bod,
            catatan: "",
            jenis_anggaran: null,
            cost_center: null,
            peruntukan: null,
            activity: null,
            type_activity: 'Non Project',
            pipeline_id: null,
            id_user_cc: null
          };
        } else {
          return {
            tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
            // bod: this.data.bod ? this.data.bod : null,
            bod: this.bod,
            catatan: this.data.catatan,
            jenis_anggaran: this.data.jenis_anggaran,
            cost_center: this.data.cost_center,
            peruntukan: this.data.peruntukan,
            activity: this.data.activity,
            type_activity: this.data.type_activity,
            pipeline_id: this.data.pipeline_id,
            id_user_cc: this.data.id_user_cc
          };
        }
      },
      getEndUserCCFiltered(){
        return this.getEndUserCCTicket
      }
    },
    methods: {
      moment,
      fetchBodPic() {
        axios({
          method: "get",
          url: this.$serviceUrl + "klaim_cc/approval_bod",
          params: {
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
            this.wo_bod = response.data.data;
            this.pageLoading = false;
          })
          .catch((err) => {
            if (err.response.status === 401) {
              if (this.mode === "Create") {
                this.$router.go(-1);
              } else {
                this.pageLoading = false;
                this.loading = false;
              }
            }
          });
      },
      handleRef() {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
  
          const informasi = {
            tanggal_pelaporan: values.tanggal_pelaporan,
            catatan: this.initialData.catatan,
            id_user_cc: values.end_user,
          };
          Event.$emit("klaimTiketInformasi", informasi);
        });
      },
      beforeRouteEnter(to, from, next) {
        this.fetchBodPic((err, post) => {
          next();
        });
      },
      clearForm() {
        this.form.resetFields();
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      changeActivity_type(val){
        console.log("changeActivity_type",val)
        if(val=="Non Project"){
          this.$nextTick(function () {
            this.form.setFieldsValue({
              activity: null,
            });
          });
        }else{
          this.$nextTick(function () {
            this.form.setFieldsValue({
                pipeline_id: null,
            });
          });
        }
      },
      filterOptionTlc(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
    },
  };
  </script>
  
  <style></style>
  